import React, { useState } from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faPhone,
  faEnvelope,
  faLocationDot,
  faClock,
  faShieldHeart,
  faMedal,
  faCheckDouble,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faYoutube,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo, openWhatsApp } = useLocalContext();
  const brand = webinfo?.name || "Your Brand";
  const [footerMessage, setFooterMessage] = useState("");
  const phoneItems = [
    webinfo?.phone
      ? { label: webinfo.phone, href: webinfo.phonecall || webinfo.phone }
      : null,
    webinfo?.phoneSecondary
      ? {
          label: webinfo.phoneSecondary,
          href: webinfo.phoneSecondaryCall || webinfo.phoneSecondary,
        }
      : null,
  ].filter(Boolean);

  return (
    <footer className="footerx" aria-label={`${brand} website footer`}>
      <div className="footerx__disclaimer" role="note" aria-live="polite">
        <FontAwesomeIcon icon={faCircleInfo} />
        <p>
          We partner only with legitimate businesses. All work follows platform
          policies and local laws. <a href="/disclaimer">Read disclaimer</a>.
        </p>
      </div>

      <section className="footerx__cta">
        <div className="footerx__cta-inner">
          <div className="footerx__cta-copy">
            <h3>Ready to accelerate growth?</h3>
            <p>Get a free plan—channels, budgets, and 90-day roadmap.</p>
          </div>

          <div className="footerx__cta-actions wp-action">
            <a
              className="btn btn-wp btn--primary"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openWhatsApp({
                  message: "Hi! I want a free growth plan + 90-day roadmap.",
                });
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp Now
            </a>

            <a className="btn btn--ghost" href="/services">
              See Our Services
            </a>
          </div>
        </div>
      </section>

      <section className="footerx__main">
        <div className="fcard fcard--brand">
          <div className="brand">
            <div className="brand__text">
              <img src="/assets/logo/favicon.png" alt="Branding Studios" className="footer-brand-logo" />
              <p>Performance marketing, made simple and measurable.</p>
            </div>
          </div>
          <form
            className="newsletter"
            onSubmit={(e) => {
              e.preventDefault();
              openWhatsApp({
                message:
                  footerMessage.trim() || "Hello! I would like to know more.",
              });
            }}
            aria-label="Send message"
          >
            <input
              type="text"
              placeholder="Send Message"
              aria-label="Send message"
              value={footerMessage}
              onChange={(e) => setFooterMessage(e.target.value)}
            />
            <button
              type="submit"
              className="newsletter__icon"
              aria-label="Send WhatsApp message"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </button>
          </form>

          <div className="socials" aria-label="Social links">
            <a
              href="#"
              aria-label="WhatsApp"
              onClick={(e) => {
                e.preventDefault();
                openWhatsApp({ message: "Hello! I need help." });
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>

            <a
              href="https://www.instagram.com/brandingstudios.in/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://www.youtube.com/@brandingstudioteam"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>

            <a href={`tel:${webinfo.phone}`} aria-label="Call Us">
              <FontAwesomeIcon icon={faPhone} />
            </a>

            <a href={`mailto:${webinfo.email}`} aria-label="Email Us">
              <FontAwesomeIcon icon={faEnvelope} />
            </a>
          </div>
        </div>

        <nav className="fcard fcard--links" aria-label="Footer quick links">
          <div>
            <h5>Solutions</h5>
            <ul>
              <li><a href="/services/film-making">Content Creation</a></li>
              <li><a href="/services/smo">Social Media (SMO)</a></li>
              <li><a href="/services/graphic-design">Graphic Designing</a></li>
              <li><a href="/services/website-development">Web Development</a></li>
              <li><a href="/services/seo">SEO Services</a></li>
            </ul>
          </div>

          <div>
            <h5>Company</h5>
            <ul>
              <li><a href="/about">About {brand}</a></li>
              <li><a href="/blogs">Blogs</a></li>
              <li><a href="/our-strategies">Our Strategies</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div>
            <h5>Legal</h5>
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms-and-condition">Terms & Conditions</a></li>
              <li><a href="/disclaimer">Disclaimer</a></li>
            </ul>
          </div>
        </nav>

        <div className="fcard fcard--contact" aria-label="Contact information">
          <h5>Contact</h5>
          <ul className="contact-list">
            <li>
              <FontAwesomeIcon icon={faPhone} />{" "}
              <span className="contact-list__phones">
                {phoneItems.map((item) => (
                  <a key={item.href} href={`tel:${item.href}`}>
                    {item.label}
                  </a>
                ))}
              </span>
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelope} />{" "}
              <a href={`mailto:${webinfo.email}`}>{webinfo.email}</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} />{" "}
              <span>{webinfo.hours || "Mon-Sat • 9am to 9pm"}</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faLocationDot} />{" "}
              <span>{webinfo.address}</span>
            </li>
          </ul>

          <div className="badges">
            <span>
              <FontAwesomeIcon icon={faShieldHeart} /> Policy-Safe
            </span>
            <span>
              <FontAwesomeIcon icon={faMedal} /> Senior Team
            </span>
            <span>
              <FontAwesomeIcon icon={faCheckDouble} /> GA4 + GTM
            </span>
          </div>
        </div>
      </section>

      <section className="footerx__trust">
        <div className="trust-item">
          <strong>2.8x</strong>
          <span>Median ROAS (PPC)</span>
        </div>
        <div className="trust-item">
          <strong>+120%</strong>
          <span>Organic Growth</span>
        </div>
        <div className="trust-item">
          <strong>48–72h</strong>
          <span>Video Turnaround</span>
        </div>
        <div className="trust-item">
          <strong>20+ countries</strong>
          <span>Global experience</span>
        </div>
      </section>

      <div className="footerx__bottom">
        <p>
          © {new Date().getFullYear()} {brand}. All rights reserved.
        </p>
        <ul className="legal-mini">
          <li><a href="/privacy-policy">Privacy</a></li>
          <li><a href="/terms-and-condition">Terms</a></li>
          <li><a href="/disclaimer">Disclaimer</a></li>
          <li><a href="/contact">Support</a></li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
